<div class="nav_container">
  <ul>
    <div class="mb-4">
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">
        Formation
      </li>
      <li>
        <a [routerLink]="['users/mesapprenants']" class="nav_item" style="padding-top: 3px; padding-bottom: 3px"
          routerLinkActive="active-link">
          <svg style="
              margin-left: -5px;
              enable-background: new 0 0 512 512;
              width: 28px;
              height: 28px;
            " version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <path
              d="M465.4,247c-2.2-22-12.4-43-28.9-58.4c-17.1-15.9-39.3-24.7-62.7-24.7c-41.5,0-77.3,27.4-88.5,67c-7-7-18.5-11.7-29.3-11.7  c-10.8,0-22.3,4.7-29.3,11.7c-11.2-39.6-47-67-88.5-67c-23.3,0-45.6,8.7-62.7,24.6C59,204,48.8,225,46.6,247H32v18h14.6  c2.2,22,12.4,43,28.9,58.4c17.1,15.9,39.3,24.7,62.7,24.7c50.8,0,92.1-41.2,92.1-92c0-0.1,0-0.1,0-0.1h0c0-9.9,11.5-21.6,25.7-21.6  s25.7,11.7,25.7,21.6h0c0,0,0,0,0,0.1c0,50.8,41.3,92,92.1,92c23.3,0,45.6-8.7,62.7-24.7c16.5-15.4,26.7-36.5,28.9-58.5H480v-18  H465.4z M373.8,333c-42.5,0-77-34.6-77-77c0-42.5,34.6-77,77-77c42.5,0,77,34.6,77,77C450.8,298.5,416.3,333,373.8,333z M138.2,333  c-42.5,0-77-34.6-77-77c0-42.5,34.6-77,77-77c42.5,0,77,34.6,77,77C215.2,298.5,180.7,333,138.2,333z"
              fill="#F3F4F6" />
          </svg>
          <span style="margin-left: 10px">Apprenants</span>
        </a>
      </li>
    </div>
    <div class="mb-4">
      <!-- ********** SIGUI ******* -->
      <li class="uppercase text-greyLighter text-sm font-bold mb-1">Sigui</li>
      <li>
        <a [routerLink]="['appels/sigui-certificat']" class="nav_item" routerLinkActive="active-link">
          <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" style="fill: #e5e8ec">
            <g id="Setting">
              <path fill="#F3F4F6" stroke="#F3F4F6" stroke-width="2"
                d="M4,12H8.059a8.9963,8.9963,0,0,0,17.882,0H60a1,1,0,0,0,0-2H25.941A8.9963,8.9963,0,0,0,8.059,10H4a1,1,0,0,0,0,2ZM17,4a7,7,0,1,1-7,7A7.0085,7.0085,0,0,1,17,4Z" />
              <path fill="#F3F4F6" stroke="#F3F4F6" stroke-width="2"
                d="M60,31H55.941a8.9963,8.9963,0,0,0-17.882,0H4a1,1,0,0,0,0,2H38.059a8.9963,8.9963,0,0,0,17.882,0H60a1,1,0,0,0,0-2ZM47,39a7,7,0,1,1,7-7A7.0085,7.0085,0,0,1,47,39Z" />
              <path fill="#F3F4F6" stroke="#F3F4F6" stroke-width="2"
                d="M60,52H33.941a8.9963,8.9963,0,0,0-17.882,0H4a1,1,0,0,0,0,2H16.059a8.9963,8.9963,0,0,0,17.882,0H60a1,1,0,0,0,0-2ZM25,60a7,7,0,1,1,7-7A7.0085,7.0085,0,0,1,25,60Z" />
            </g>
          </svg>
          <span class="ml-3">Gestion des Certificats</span>
        </a>
      </li>
      <li>
        <a [routerLink]="['appels/listAppels']" class="nav_item" routerLinkActive="active-link">
          <svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg"
            style="width: 28px; height: 22px; margin-left: -4px">
            <rect fill="none" />
            <path d="M159.4,40A80.1,80.1,0,0,1,216,96.6" fill="none" stroke="#F3F4F6" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="8" />
            <path d="M151.1,70.9a47.9,47.9,0,0,1,34,34" fill="none" stroke="#fff" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="8" />
            <path
              d="M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z"
              fill="none" stroke="#F3F4F6" stroke-linecap="round" stroke-linejoin="round" stroke-width="12" />
          </svg>
          <span class="ml-2">Gestion des Appels</span>
        </a>
      </li>

      <!-- *********************** Sessions hORS sigui ********************* -->
      <li>
        <button (click)="toggleCollapse(3)" class="toggle-button bg-transparent pr-5">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="none" stroke="#E5E8EC" stroke-width="30"
              d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
          </svg>
          Sessions Hors SIGUI
          <i [class.pi]="true" [class.pi-chevron-down]="sections[2].isCollapsed"
            [class.pi-chevron-up]="!sections[2].isCollapsed" style="margin-left: auto"></i>
        </button>
        <div [@slideToggle]="sections[2].isCollapsed ? 'closed' : 'open'" class="animated-paragraph"
          style="margin-left: 8px">
          <ul>
            <li *ngFor="let offtract of listofftrack">
              <div (click)="toggleOfftrack(offtract)" class="nav_item cursor-pointer flex items-center py-1">
                <i [class]="
                    offtract.isCollapsed
                      ? 'pi pi-chevron-right'
                      : 'pi pi-chevron-down'
                  " class="text-xs ms-2 text-white"></i>
                <span class="ms-2 text-sm font-bold uppercase text-white">
                  {{ offtract.familyMetierName }}</span>
              </div>
              <ul *ngIf="!offtract.isCollapsed">
                <li *ngFor="let cohorteName of offtract.cohorteNames">
                  <a class="nav_item flex items-center py-1 cursor-pointer" routerLinkActive="active-link"
                    (click)="sessionChangeHparcours(cohorteName)">
                    <i class="pi pi-chevron-right text-xs ms-4"></i>
                    <span class="ms-2 text-xs">{{ cohorteName }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </li>
      <br />
      <div class="mb-4">
        <!-- Fond d'Amorcage -->
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Accompagnement
        </li>
        <li>
          <a style="cursor:pointer" (click)="showIframe = true" class="nav_item">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path fill="#E5E8EC" stroke="black" stroke-width="6"
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
            </svg>
            <span class="ml-3">Connexion</span>
          </a>
        </li>
      </div>
    </div>
  </ul>
</div>
<app-iframe-modal *ngIf="showIframe" [iframeUrl]="urlFondAmorcage" (closed)="showIframe = false" />